// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3yQl_","buttonPrimary":"Button_buttonPrimary__3BQqr Button_button__3yQl_","link":"Button_link__1NXVy"};